import clsx from "clsx";

import NavigationDrawerBackground from "@ui/components/brand/theverge/NavigationDrawerBackground/NavigationDrawerBackground";
import VergeLogo from "@ui/components/brand/theverge/VergeLogo";
import VergeLogoInline from "@ui/components/brand/theverge/VergeLogoInline";
import VergePrimaryNavigation from "@ui/components/brand/theverge/VergePrimaryNavigation";
import VergeSubscribeButton from "@ui/components/brand/theverge/VergeSubscribeButton";
import { NavigationConfig } from "@ui/context/component-config-context";
import vergeLight from "@ui/themes/theverge-light.css";
import { NavItem } from "@voxmedia/duet-context/context/global-data-context";

import * as styles from "./Navigation.theverge.config.css";

const navigationConfig: NavigationConfig = {
  Logo: VergeLogo,
  NotificationsLogo: VergeLogo,
  showAuth: true,
  showNotificationsButton: true,
  showStickyNavCommentCount: true,
  showSubscribeInNav: true,
  primaryNavigationComponent: VergePrimaryNavigation,
  getDrawerComponents: () => ({
    background: <NavigationDrawerBackground />,
    endSection: <VergeSubscribeButton />,
  }),
  cta: {
    desktop: null,
    mobile: null,
  },
  linkMenu: {
    linkClassName: styles.linkMenuLink,
    showLinkLines: false,
  },
  rightMenuButtons: {
    desktop: () => <></>,
    mobile: () => <></>,
  },
  getPinnedItems: (_, mainNav: NavItem[] | null) => {
    const navItems = mainNav || [];
    return [<VergeLogoInline key="verge-logo" />, ...navItems.slice(0, 6)];
  },
  drawerItems: [],
  getDrawerItems: (_, mainNav: NavItem[] | null) => mainNav ?? [],
  componentContext: {},
  notificationsClass: clsx(vergeLight, styles.notificationsPopover),
};

export default navigationConfig;
